<template>
  <!--srccomponentsgui_cardgui_cardvuehtmlStart-->

  <div id="defaultId1" class="uUIRzUi">
    <div id="g3963c" class="operations-head-content" v-if="isShowLabel">
      <div id="gb37c4" class="uWqiWvx">
        <slot id="idTRjK3z" name="left_icon" data="我是数据"> </slot>
        <span id="idIoM6Nf" class="operations-head detail_title_20"
          >{{ label }}
        </span>
      </div>
      <slot id="c3ad37" name="right_view" data="我是数据"> </slot>
    </div>
    <slot id="c03b8a"> </slot>
  </div>
  <!--srccomponentsgui_cardgui_cardvuehtmlEnd-->
</template>
<script>
// interfaceCode
//importStart

//importEnd

export default {
  name: "",

  props: {
    // srccomponentsgui_cardgui_cardvuePropsStart

    // srccomponentsgui_cardgui_cardvuePropsEnd

    isShowLabel: {
      type: Boolean,
      default: true,
    },

    label: {
      type: String,
      default: "",
    },
  },

  mounted() {
    // defaultLoad
    // srccomponentsgui_cardgui_cardvueMountedStart
    // srccomponentsgui_cardgui_cardvueMountedEnd
  },
  components: {},
  data() {
    return {
      // insertData
      // srccomponentsgui_cardgui_cardvueDataStart
      // srccomponentsgui_cardgui_cardvueDataEnd
    };
  },
  methods: {
    // insertMethod
    // srccomponentsgui_cardgui_cardvueMethodStart
    // default
    default() {},
    // srccomponentsgui_cardgui_cardvueMethodEnd
  },
  computed: {},
};
</script>
<style>
.uUIRzUi {
  padding: 30px 40px 0;
  box-shadow: 0px 2px 14px 0px rgba(0, 0, 0, 0.12);
  background-color: #ffffff;
  border-radius: 10px;
}

.uWqiWvx {
  display: flex;
}

@media screen and (max-width: 1920px) {
  .uUIRzUi {
    padding: 22px 30px 0;
    box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.12);
  }
}
@media screen and (max-width: 1439px) {
  .uUIRzUi,
  .operations-content {
    padding: 20px 26px 0;
    box-shadow: 0px 2px 9px 0px rgba(0, 0, 0, 0.12);
  }
}
</style>
